module.exports = __webpack_public_path__ + "static/media/features-split-image-01.5ea21440.svg";